import { useEffect } from 'react'

export default function TermsOfService() {
	useEffect(() => {
		// Create and append the script
		const script = document.createElement('script')
		script.id = 'termly-jssdk'
		script.src = 'https://app.termly.io/embed-policy.min.js'
		script.async = true

		const tjs = document.getElementsByTagName('script')[0]
		if (tjs && tjs.parentNode) {
			tjs.parentNode.insertBefore(script, tjs)
		}

		// Cleanup the script when the component unmounts
		return () => {
			const existingScript = document.getElementById('termly-jssdk')
			if (existingScript) {
				existingScript.remove()
			}
		}
	}, [])

	return (
		<div
			// @ts-ignore
			name="termly-embed"
			data-id="a1da231c-3627-45c5-8193-463ef543fc56"
		></div>
	)
}
